<template lang="pug">
table-base.study-result-detail-score-table
  //- ヘッダー部
  table-row-base.study-result-detail-score-table__row-header.text-medium
    table-header-base.study-result-detail-score-table__row-header__cell
    table-header-base.study-result-detail-score-table__row-header__cell.align-center
      slot(name='totalScoreHeader')
    table-header-base.study-result-detail-score-table__row-header__cell.align-center
      slot(name='knowledgeScoreHeader')
    table-header-base.study-result-detail-score-table__row-header__cell.align-center
      slot(name='thinkingScoreHeader')
  template(v-if='studyResultDetailScore')
    //- 一覧表示部
    table-row-base.study-result-detail-score-table__row
      table-data-base.study-result-detail-score-table__row__cell.text-medium.font-bold
        .study-result-detail-score-table__row__cell__text
          slot(name='scoreLabel')
      table-data-base.study-result-detail-score-table__row__cell.text-small
        .study-result-detail-score-table__row__cell__text {{ studyResultDetailScore.totalScore }}
      table-data-base.study-result-detail-score-table__row__cell.text-small
        .study-result-detail-score-table__row__cell__text {{ studyResultDetailScore.knowledgeScore }}
      table-data-base.study-result-detail-score-table__row__cell.text-small
        .study-result-detail-score-table__row__cell__text {{ studyResultDetailScore.thinkingScore }}
    //- 平均点は一時的に非表示
    //- table-row-base.study-result-detail-score-table__row
    //-   table-data-base.study-result-detail-score-table__row__cell.text-medium.font-bold
    //-     .study-result-detail-score-table__row__cell__text
    //-       slot(name='averageLabel')
    //-   table-data-base.study-result-detail-score-table__row__cell.text-small
    //-     .study-result-detail-score-table__row__cell__text {{ studyResultDetailScore.totalAverage }}
    //-   table-data-base.study-result-detail-score-table__row__cell.text-small
    //-     .study-result-detail-score-table__row__cell__text {{ studyResultDetailScore.knowledgeAverage }}
    //-   table-data-base.study-result-detail-score-table__row__cell.text-small
    //-     .study-result-detail-score-table__row__cell__text {{ studyResultDetailScore.thinkingAverage }}
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import TableBase from '@/components/atoms/TableBase.vue'
import TableRowBase from '@/components/atoms/TableRowBase.vue'
import TableHeaderBase from '@/components/atoms/TableHeaderBase.vue'
import TableDataBase from '@/components/atoms/TableDataBase.vue'
import { StudyResultDetailScore } from '@/models/studyResultDetailModel'

/**
 * テスト結果詳細得点情報テーブル
 */
@Component({
  components: {
    TableBase,
    TableRowBase,
    TableHeaderBase,
    TableDataBase,
  },
})
export default class StudyResultDetailScoreTable extends Vue {
  // テスト結果詳細得点情報
  @Prop()
  studyResultDetailScore!: StudyResultDetailScore
}
</script>

<style lang="stylus" scoped>
.study-result-detail-score-table
  width 100%
  table-layout fixed

  &__row-header,
  &__row
    border-bottom 1px solid var(--color-manager-list__border)

  &__row-header
    background var(--color-manager-list__background)

    &__cell
      padding 10px 20px

  &__row
    background var(--color-manager-list__background)
    height 55px

    &__cell
      padding 0 20px

      &__text
        display flex
        justify-content center

    &:hover
      background var(--color-manager-list__hover)
</style>
